export default "__VITE_ASSET__DU8CGKaE__"